<template>
  <div v-if="creditData && creditData.id">
    <div v-if="creditData.type === 'out' && products.length" class="table-wrapper">
      <v-data-table
        :footer-props="{
          'items-per-page-text': 'Số dữ liệu mỗi trang',
          'items-per-page-options': [5, 10, -1],
        }"
        disable-sort
        :headers="headers"
        :items="products"
        :items-per-page="5"
        :server-items-length="products.length"
        no-data-text="Không có dữ liệu"
      >
        <template v-slot:[`item.priceEach`]="{ item }">
          {{ Number(item.priceEach).toLocaleString('en-US') }}
        </template>
        <template v-slot:[`item.price`]="{ item }">
          {{ Number(item.price).toLocaleString('en-US') }}
        </template>
        <template v-slot:[`item.name`]="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <div v-on="on" v-bind="attrs" class="trundle-text">{{ item.name }}</div>
            </template>
            <span class="white--text text-justify">
              {{ item.name }}
            </span>
          </v-tooltip>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
import { get } from 'lodash'
export default {
  props: {
    creditData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      products: [],
      headers: [
        { text: 'STT', value: 'index', width: '40px' },
        { text: 'Tên', value: 'name', width: '150px' },
        { text: 'Số lượng', value: 'quantity', width: '100px', align: 'end' },
        { text: 'Đơn giá', value: 'priceEach', width: '120px', align: 'end' },
        { text: 'Thành tiền', value: 'price', width: '120px', align: 'end' },
      ],
    }
  },
  watch: {
    creditData: {
      handler(val) {
        if (val) {
          let data = get(val, 'order.products', [])
          this.products = data.map((v, index) => ({
            ...v,
            index: index + 1,
            price: Number(v.priceEach) * Number(v.quantity),
          }))
        }
      },
      immediate: true,
    },
  },
}
</script>

<style lang="scss" scoped>
.table-wrapper {
  margin: 16px 0;
  border: 1px solid rgba(0, 0, 0, 0.1);
  user-select: none;
  display: inline-block;
}

.trundle-text {
  max-width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
